(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dreamey-skin-listicle-v2"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var SVG_NS = 'http://www.w3.org/2000/svg';
  var SVG_TAGS = { svg:1, rect:1, circle:1, ellipse:1, path:1, polyline:1, polygon:1, g:1, line:1, text:1, tspan:1, defs:1, linearGradient:1, radialGradient:1, stop:1, clipPath:1, use:1 };
  var UNITLESS = { opacity:1, lineHeight:1, fontWeight:1, flex:1, flexGrow:1, flexShrink:1, order:1, zIndex:1, fillOpacity:1, strokeOpacity:1, aspectRatio:1, gridRow:1, gridColumn:1 };
  var ATTR_MAP = { strokeWidth:'stroke-width', strokeOpacity:'stroke-opacity', strokeLinecap:'stroke-linecap', strokeLinejoin:'stroke-linejoin', strokeDasharray:'stroke-dasharray', strokeDashoffset:'stroke-dashoffset', fillOpacity:'fill-opacity', clipPath:'clip-path' };

  function kebab(s) { return s.replace(/[A-Z]/g, function (m) { return '-' + m.toLowerCase(); }); }
  function styleStr(o) {
    var s = '';
    for (var k in o) {
      var v = o[k];
      if (typeof v === 'number' && !UNITLESS[k]) v = v + 'px';
      s += kebab(k) + ':' + v + ';';
    }
    return s;
  }
  function h(tag, props) {
    var isSvg = !!SVG_TAGS[tag];
    var el = isSvg ? document.createElementNS(SVG_NS, tag) : document.createElement(tag);
    if (props) {
      for (var k in props) {
        if (k === 'key') continue;
        var v = props[k];
        if (v == null || v === false) continue;
        if (k === 'style') el.setAttribute('style', styleStr(v));
        else if (k === 'className') el.setAttribute('class', v);
        else el.setAttribute(ATTR_MAP[k] || k, v);
      }
    }
    function add(c) {
      if (c == null || c === false || c === true) return;
      if (Array.isArray(c)) { c.forEach(add); return; }
      if (c instanceof Node) { el.appendChild(c); return; }
      el.appendChild(document.createTextNode(String(c)));
    }
    for (var i = 2; i < arguments.length; i++) add(arguments[i]);
    return el;
  }

  function buildVisuals() {
    var ink='#323232', sub='#6B6560', tert='#89827A', sand='#E5DDD2', oat='#D4CBC0',
      cashmere='#F0EAE0', linen='#FDFCFA', blue='#4A7A96', blueH='#3D6A84',
      sky='#8AAFC4', dawn='#C8DCE8', wash='#EBF2F6';

    var eyebrow = function (c) { return { fontFamily:"'Inter',sans-serif", fontSize:11, fontWeight:600, letterSpacing:'0.14em', textTransform:'uppercase', color:c||tert }; };

    var fig = function (body, note) {
      return h('div', { style:{ background:linen, border:'1px solid '+sand, padding:'26px 26px 22px', height:372, display:'flex', flexDirection:'column' } },
        h('div', { style:{ flex:1, display:'flex', flexDirection:'column', justifyContent:'center', minHeight:0 } }, body),
        note && h('div', { style:{ fontFamily:"'Inter',sans-serif", fontStyle:'italic', fontSize:12, lineHeight:1.5, color:tert, marginTop:18, borderTop:'1px solid '+sand, paddingTop:14, flex:'none' } }, note)
      );
    };

    var pill = function (t) { return h('span', { key:t, style:{ display:'inline-block', padding:'6px 12px', border:'1px solid '+sand, borderRadius:999, fontFamily:"'Inter',sans-serif", fontSize:11, fontWeight:600, letterSpacing:'0.07em', textTransform:'uppercase', color:sub, background:linen } }, t); };

    var dropCol = function (mat, behav, svg) {
      return h('div', { key:mat, style:{ flex:1, minWidth:0, display:'flex', flexDirection:'column', alignItems:'center', gap:10 } },
        h('div', { style:Object.assign({}, eyebrow(tert), { textAlign:'center' }) }, mat), svg,
        h('div', { style:{ fontFamily:"'Satoshi',sans-serif", fontWeight:700, fontSize:15, color:ink } }, behav));
    };
    var svgWrap = function (kids) { return h('svg', { viewBox:'0 0 100 96', width:'100%', style:{ maxWidth:118, display:'block' } }, kids); };
    var cottonSvg = svgWrap([
      h('rect',{ key:'f', x:8, y:46, width:84, height:42, fill:cashmere, stroke:oat, strokeWidth:1 }),
      h('ellipse',{ key:'p1', className:'soak', style:{ '--sd':'0.2s', '--dd':'0s' }, cx:50, cy:68, rx:30, ry:15, fill:'#CBB99E', opacity:0.7 }),
      h('ellipse',{ key:'p2', className:'soak', style:{ '--sd':'0.35s', '--dd':'0.15s' }, cx:50, cy:63, rx:17, ry:8, fill:'#B19877', opacity:0.6 }),
      h('path',{ key:'d', className:'drp', style:{ '--dd':'0s' }, d:'M50 22 C44 32 40 38 50 41 C60 38 56 32 50 22 Z', fill:blue, opacity:0.4 })
    ]);
    var silkSvg = svgWrap([
      h('rect',{ key:'f', x:8, y:46, width:84, height:42, fill:'#ECEDE8', stroke:oat, strokeWidth:1 }),
      h('rect',{ key:'sheen', x:8, y:46, width:84, height:7, fill:'#ffffff', opacity:0.55 }),
      h('path',{ key:'d', className:'drp', style:{ '--dd':'0.35s' }, d:'M50 8 C45 16 42 21 50 23.5 C58 21 55 16 50 8 Z', fill:blue, opacity:0.4 }),
      h('ellipse',{ key:'b', className:'bead', style:{ '--sd':'0.3s', '--dd':'0.35s' }, cx:50, cy:40, rx:15, ry:11, fill:blue, opacity:0.5 }),
      h('ellipse',{ key:'hi', className:'bead', style:{ '--sd':'0.45s', '--dd':'0.35s' }, cx:45, cy:36, rx:4, ry:2.4, fill:'#ffffff', opacity:0.7 })
    ]);
    var cloudSvg = svgWrap([
      h('rect',{ key:'f', x:8, y:46, width:84, height:42, fill:wash, stroke:blue, strokeWidth:1, strokeOpacity:0.5 }),
      h('path',{ key:'d', className:'drp', style:{ '--dd':'0.7s' }, d:'M50 70 C46.5 75 45 78 50 79 C55 78 53.5 75 50 70 Z', fill:blue, opacity:0.5 })
    ].concat([34,50,66].map(function (x,i) {
      return h('g',{ key:'v'+i, className:'vapor', style:{ '--vd':(0.35+i*0.45)+'s' }, stroke:blue, strokeWidth:2, strokeLinecap:'round', strokeLinejoin:'round', opacity:0.7, fill:'none' },
        h('path',{ d:'M'+x+' 40 L'+x+' 17', strokeDasharray:'2 5' }),
        h('path',{ d:'M'+(x-5)+' 24 L'+x+' 15 L'+(x+5)+' 24' }));
    })));
    var dropletTest = fig(
      h('div', { style:{ display:'flex', gap:14, alignItems:'flex-end' } }, dropCol('Cotton','Sponge',cottonSvg), dropCol('Silk','Raincoat',silkSvg), dropCol('CloudThera','Chimney',cloudSvg)),
      '34% greater moisture vapor transmission than cotton, 570 vs 425 g/m²/h, independent lab.'
    );

    var petri = function (n, color, label, amp) {
      var out = [h('circle',{ key:'b', cx:50, cy:50, r:45, fill:'#FAF7F2', stroke:oat, strokeWidth:1.5 })];
      for (var i=0;i<n;i++) {
        var ang=i*2.399; var rad=7+(i/Math.max(n,1))*33;
        var dx=(Math.sin(i*12.9898)*3.2*amp).toFixed(2), dy=(Math.cos(i*78.233)*3.2*amp).toFixed(2);
        out.push(h('circle',{ key:i, className:'pd', style:{ '--pdel0':(i*28)+'ms', '--dx':dx+'px', '--dy':dy+'px', '--pdur':(2.6+((i*7)%5)*0.55)+'s' }, cx:50+rad*Math.cos(ang), cy:50+rad*Math.sin(ang), r:2.6, fill:color }));
      }
      return h('div', { style:{ flex:1, display:'flex', flexDirection:'column', alignItems:'center', gap:12 } },
        h('svg', { viewBox:'0 0 100 100', width:'100%', style:{ maxWidth:172 } }, out),
        h('div', { style:{ fontFamily:"'Inter',sans-serif", fontSize:12, fontWeight:700, letterSpacing:'0.07em', textTransform:'uppercase', color:sub } }, label));
    };
    var petriCompare = fig(
      h('div', { style:{ display:'flex', gap:12, alignItems:'center', justifyContent:'center' } },
        petri(40, '#B5896B', 'Cotton', 1),
        petri(13, blue, 'CloudThera', 0.4)),
      '3× less bacteria vs cotton, cultured surface, Hohenstein Institute.'
    );

    var vcols = function (items) {
      return h('div', { style:{ display:'flex', alignItems:'flex-end', justifyContent:'center', gap:34, height:212 } },
        items.map(function (it,i) {
          return h('div', { key:it.label, style:{ display:'flex', flexDirection:'column', alignItems:'center', height:'100%', justifyContent:'flex-end', flex:'0 0 76px' } },
            h('div', { 'data-count':parseFloat(it.value), 'data-dec':'0', style:{ fontFamily:"'Satoshi',sans-serif", fontWeight:700, fontSize:16, color: it.strong?ink:sub, marginBottom:8 } }, it.value),
            h('div', { className:'bar', style:{ width:'100%', height:it.pct+'%', background:it.color, minHeight:4, animationDelay:(i*0.15)+'s' } }),
            h('div', { style:{ fontFamily:"'Inter',sans-serif", fontSize:12, fontWeight:600, color: it.strong?ink:sub, marginTop:10, textAlign:'center' } }, it.label));
        }));
    };
    var mvtrColumns = fig(
      vcols([{ label:'Cotton', value:'425', pct:53.34, color:oat, strong:false }, { label:'CloudThera', value:'570', pct:80, color:blue, strong:true }]),
      'Moisture vapor transmission, g/m²/h, higher moves more water away from skin. +34% vs cotton.'
    );

    var profile = function (label, value, amp, color, strong, dur, rough) {
      var pts=[];
      for (var x=0;x<=180;x+=2) {
        var y = rough
          ? 20 + amp*(Math.sin(x*Math.PI/15) + 0.45*Math.sin(x*Math.PI/6 + 0.6) + 0.22*Math.sin(x*Math.PI/10 + 1.9))
          : 20 + amp*Math.sin(x*Math.PI/30) + amp*0.5*Math.sin(x*Math.PI/15);
        pts.push(x+','+y.toFixed(2));
      }
      return h('div', { key:label, style:{ marginBottom:18 } },
        h('div', { style:{ display:'flex', justifyContent:'space-between', alignItems:'baseline', marginBottom:6 } },
          h('span', { style:{ fontFamily:"'Inter',sans-serif", fontSize:12, fontWeight:600, color: strong?ink:sub } }, label),
          h('span', { style:{ fontFamily:"'Satoshi',sans-serif", fontWeight:700, fontSize:14, color: strong?ink:sub } }, value)),
        h('svg', { viewBox:'0 0 120 40', width:'100%', preserveAspectRatio:'none', style:{ height:34, display:'block', overflow:'hidden' } },
          h('g', { className:'flowline', style:{ '--fdur':dur+'s' } },
            h('polyline', { points:pts.join(' '), fill:'none', stroke:color, strokeWidth: strong?2.4:1.8, strokeLinecap:'round', strokeLinejoin:'round' }))));
    };
    var surfaceProfile = fig(
      h('div', {}, profile('Cotton','0.25 µm',8,oat,false,4.5,true), profile('Silk','0.15 µm',5,sky,false,6,true), profile('CloudThera','0.11 µm',2.2,blue,true,7.5,true)),
      'Surface roughness profile, flatter is smoother. 56% less friction than cotton, smoother than silk.'
    );

    var person = function (filled, i) {
      return h('svg', { viewBox:'0 0 24 30', width:21, className:'ppl', style:{ display:'block', animationDelay:(i*0.07)+'s' }, key:'p'+i },
        h('circle', { cx:12, cy:7, r:5, fill: filled?blue:'none', stroke: filled?'none':oat, strokeWidth:1.6 }),
        h('path', { d:'M2 30 C2 20 6 16 12 16 C18 16 22 20 22 30 Z', fill: filled?blue:'none', stroke: filled?'none':oat, strokeWidth:1.6 }));
    };
    var pictograph = fig(
      h('div', {},
        h('div', { style:{ display:'grid', gridTemplateColumns:'repeat(5,1fr)', gap:'16px 14px', justifyItems:'center', maxWidth:250, margin:'0 auto' } },
          [0,1,2,3,4,5,6,7,8,9].map(function (i) { return person(i<9,i); })),
        h('div', { style:{ display:'flex', alignItems:'center', gap:10, marginTop:24 } },
          h('span',{ style:{ fontFamily:"'Inter',sans-serif", fontSize:11, fontWeight:600, color:tert } }, 'Day 0'),
          h('div',{ className:'gline', style:{ flex:1, height:6, background:'linear-gradient(90deg,'+sand+','+blue+')' } }),
          h('span',{ style:{ fontFamily:"'Satoshi',sans-serif", fontWeight:700, fontSize:13, color:blueH } }, 'Day 30')),
        h('div', { style:{ fontFamily:"'Inter',sans-serif", fontSize:14, lineHeight:1.5, color:sub, textAlign:'center', marginTop:22, maxWidth:'32ch', marginLeft:'auto', marginRight:'auto' } }, '9 of 10 report noticeably better results')),
      '9 out of 10 report better skin & sleep, survey of over 1,000 sleepers.'
    );

    var washCurve = (function () {
      var pts=[[0,72],[30,52],[58,36],[84,22],[108,12],[120,8]];
      var poly=pts.map(function (p) { return p[0]+','+p[1]; }).join(' ');
      var area=poly+' 120,84 0,84';
      return fig(
        h('div', {},
          h('svg', { viewBox:'0 0 120 84', width:'100%', preserveAspectRatio:'none', style:{ display:'block', height:230 } },
            h('polygon',{ className:'ppl', style:{ animationDelay:'0.6s' }, points:area, fill:wash }),
            h('polyline',{ className:'tr', points:poly, fill:'none', stroke:blue, strokeWidth:2.4, strokeLinecap:'round', strokeLinejoin:'round' })),
          h('div', { style:{ display:'flex', justifyContent:'space-between', marginTop:8, fontFamily:"'Inter',sans-serif", fontSize:11, fontWeight:600, color:sub } },
            h('span',{}, 'Wash 1'), h('span',{}, 'Wash 10'), h('span',{}, 'Wash 20'))),
        'Softens with every wash, where bamboo & cotton degrade. 38 cN/tex, ~50% stronger than cotton.'
      );
    })();

    var hoursVisual = fig(
      h('div', {},
        h('div', {},
          h('div', { style:{ display:'flex', alignItems:'baseline', gap:6 } },
            h('span', { 'data-count':'2920', 'data-dec':'0', style:{ fontFamily:"'Satoshi',sans-serif", fontWeight:700, fontSize:'clamp(40px,5vw,58px)', lineHeight:1, letterSpacing:'-0.02em', color:ink } }, '2,920'),
            h('span', { style:{ fontFamily:"'Satoshi',sans-serif", fontWeight:700, fontSize:26, letterSpacing:'-0.02em', color:blue } }, 'hrs')),
          h('div', { style:{ fontFamily:"'Inter',sans-serif", fontSize:15, color:sub, marginTop:10, lineHeight:1.45, maxWidth:'28ch' } }, 'of skin-on-fabric contact a year, longer than any treatment, mask, or active touches your skin.')),
        h('div', { style:{ display:'flex', flexWrap:'wrap', gap:8, marginTop:22 } }, ['OEKO-TEX certified','Certified hypoallergenic','PETA-vegan'].map(pill))
      )
    );

    return {
      reason1visual: petriCompare,
      reason2visual: hoursVisual,
      reason3visual: dropletTest,
      reason4visual: mvtrColumns,
      reason5visual: surfaceProfile,
      reason6visual: pictograph,
      reason7visual: washCurve
    };
  }

  function init(root) {
    var visuals = buildVisuals();
    Object.keys(visuals).forEach(function (id) {
      var el = root.querySelector('#' + id);
      if (el && visuals[id]) el.appendChild(visuals[id]);
    });
    setupMotion(root);
    setupMarquee(root);
    setupProductScroll(root);
    setupStickyCta(root);
  }

  /* Sticky shop bar. Shows once the hero CTA has scrolled above the viewport
     (not merely below it, which is where it sits on a phone at load), and
     hides while the product cards are on screen so buy buttons never stack. */
  function setupStickyCta(root) {
    var bar = root.querySelector('.dsl-sticky');
    var hero = root.querySelector('.hero-cta');
    if (!bar || !hero || !('IntersectionObserver' in window)) return;
    var cards = root.querySelector('.dreamey-product-showcase__scroll');
    var heroAbove = false, cardsIn = false;

    function apply() {
      var show = heroAbove && !cardsIn;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    new IntersectionObserver(function (entries) {
      var e = entries[entries.length - 1];
      heroAbove = !e.isIntersecting && e.boundingClientRect.top < 0;
      apply();
    }, { threshold: 0 }).observe(hero);

    if (cards) {
      new IntersectionObserver(function (entries) {
        cardsIn = entries[entries.length - 1].isIntersecting;
        apply();
      }, { threshold: 0 }).observe(cards);
    }
  }

  function setupProductScroll(root) {
    var el = root.querySelector('.dreamey-product-showcase__scroll');
    if (!el) return;
    var TH = 6, down = false, dragging = false, startX = 0, startLeft = 0;
    el.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      down = true; dragging = false; startX = e.pageX; startLeft = el.scrollLeft;
    });
    window.addEventListener('mousemove', function (e) {
      if (!down) return;
      var dx = e.pageX - startX;
      if (!dragging && Math.abs(dx) > TH) { dragging = true; el.classList.add('is-dragging'); }
      if (dragging) { el.scrollLeft = startLeft - dx; e.preventDefault(); }
    });
    window.addEventListener('mouseup', function () {
      if (!down) return;
      down = false;
      if (!dragging) return;
      var suppress = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
      el.addEventListener('click', suppress, { capture: true, once: true });
      setTimeout(function () { el.removeEventListener('click', suppress, { capture: true }); el.classList.remove('is-dragging'); dragging = false; }, 0);
    });
  }

  function setupMarquee(root) {
    var wrap = root.querySelector('.marquee-wrap');
    if (!wrap) return;
    var track = wrap.querySelector('.marquee-track');
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var half = 0;
    function measure() { half = track ? track.scrollWidth / 2 : 0; }
    measure();
    var dragging = false, hover = false, startX = 0, startScroll = 0, pos = 0;
    var auto = !reduced, speed = 0.35;
    function step() {
      if (!half) measure();
      if (auto && !dragging && !hover && half) {
        // Accumulate a float position: mobile browsers round scrollLeft to integers,
        // so `+= 0.35` alone never advances. Tracking pos and assigning it works everywhere.
        pos += speed;
        if (pos >= half) pos -= half;
        wrap.scrollLeft = pos;
      } else {
        pos = wrap.scrollLeft;
      }
      requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
    window.addEventListener('load', measure);
    wrap.addEventListener('mouseenter', function () { hover = true; });
    wrap.addEventListener('mouseleave', function () { hover = false; });
    wrap.addEventListener('dragstart', function (e) { e.preventDefault(); });
    wrap.addEventListener('pointerdown', function (e) {
      dragging = true; wrap.classList.add('dragging');
      startX = e.clientX; startScroll = wrap.scrollLeft;
      try { wrap.setPointerCapture(e.pointerId); } catch (_) {}
    });
    wrap.addEventListener('pointermove', function (e) {
      if (!dragging || !half) return;
      wrap.scrollLeft = startScroll - (e.clientX - startX);
      if (wrap.scrollLeft <= 0) { wrap.scrollLeft += half; startScroll += half; }
      else if (wrap.scrollLeft >= half) { wrap.scrollLeft -= half; startScroll -= half; }
    });
    function endDrag() { dragging = false; wrap.classList.remove('dragging'); }
    wrap.addEventListener('pointerup', endDrag);
    wrap.addEventListener('pointercancel', endDrag);
    window.addEventListener('resize', measure);
  }

  function setupMotion(root) {
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var fmt = function (v, dec) { return dec > 0 ? v.toFixed(dec) : Math.round(v).toLocaleString('en-US'); };
    var runCount = function (el) {
      if (el.getAttribute('data-cnt-done')) return;
      el.setAttribute('data-cnt-done', '1');
      var target = parseFloat(el.getAttribute('data-count'));
      if (isNaN(target)) return;
      var dec = parseInt(el.getAttribute('data-dec') || '0', 10);
      if (reduced) { el.textContent = fmt(target, dec); return; }
      var t0 = performance.now(), dur = 1500;
      var step = target >= 1000 ? 10 : 1;
      var tick = function (now) {
        var t = Math.min(1, (now - t0) / dur);
        var eased = 1 - Math.pow(1 - t, 3);
        var v = target * eased;
        if (t < 1 && step > 1 && dec === 0) v = Math.round(v / step) * step;
        el.textContent = fmt(t < 1 ? v : target, dec);
        if (t < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };

    var toArr = function (nl) { return Array.prototype.slice.call(nl); };
    var addReveal = function (el, i) { if (!el) return; el.classList.add('reveal'); if (i != null) el.style.setProperty('--i', Math.min(i, 12)); };
    var stagger = function (list) { toArr(list).forEach(function (el, i) { addReveal(el, i); }); };

    var statCells = root.querySelectorAll('.stat-grid > div');
    stagger(statCells);
    toArr(statCells).forEach(function (cell) {
      toArr(cell.querySelectorAll('span, div')).forEach(function (c) {
        var txt = (c.textContent || '').trim();
        if (!c.children.length && /^[0-9]+(\.[0-9]+)?$/.test(txt) && !c.hasAttribute('data-count')) {
          c.setAttribute('data-count', txt);
          c.setAttribute('data-dec', txt.indexOf('.') >= 0 ? String(txt.split('.')[1].length) : '0');
        }
      });
    });

    toArr(root.querySelectorAll('[data-rv]')).forEach(function (v) {
      var copy = v.previousElementSibling;
      if (copy) stagger(copy.children);
    });

    toArr(root.querySelectorAll('[data-stagger]')).forEach(function (grp) { stagger(grp.children); });

    var dg = root.querySelector('.doctor-grid'); if (dg) stagger(dg.children);

    stagger(root.querySelectorAll('details.faq-item'));

    // Comparison table: reveal one row at a time (staggered), like the home page
    stagger(root.querySelectorAll('.dsl-trow'));

    toArr(root.querySelectorAll('h2')).forEach(function (hEl) {
      if (hEl.closest('.reveal')) return;
      var prev = hEl.previousElementSibling;
      if (prev && !prev.classList.contains('reveal')) addReveal(prev, 0);
      addReveal(hEl, prev ? 1 : 0);
    });

    toArr(root.querySelectorAll('.pad')).forEach(function (sec) {
      var i = 0;
      toArr(sec.children).forEach(function (child) {
        if (child.classList.contains('reveal') || child.hasAttribute('data-rv') ||
            child.hasAttribute('data-stagger') || child.querySelector('.reveal, [data-rv]')) { i++; return; }
        addReveal(child, i++);
      });
    });

    addReveal(root.querySelector('.mq-body'));

    var revealEls = root.querySelectorAll('.reveal, [data-rv]');

    if (reduced || !('IntersectionObserver' in window)) {
      toArr(revealEls).forEach(function (el) {
        el.classList.add('is-in');
        if (el.hasAttribute('data-rv')) el.classList.add('rv-in');
      });
      toArr(root.querySelectorAll('[data-count]')).forEach(runCount);
      return;
    }

    root.classList.add('anim-ready');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        el.classList.add('is-in');
        if (el.hasAttribute('data-rv')) el.classList.add('rv-in');
        toArr(el.querySelectorAll('[data-count]:not([data-cnt-done])')).forEach(runCount);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    toArr(revealEls).forEach(function (el) { io.observe(el); });
  }

  function boot() {
    var roots = document.querySelectorAll('.dreamey-skin-listicle-v2');
    Array.prototype.slice.call(roots).forEach(function (root) {
      if (root.getAttribute('data-dsl-init')) return;
      root.setAttribute('data-dsl-init', '1');
      init(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dreamey-skin-listicle"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var SVG_NS = 'http://www.w3.org/2000/svg';
  var SVG_TAGS = { svg:1, rect:1, circle:1, ellipse:1, path:1, polyline:1, polygon:1, g:1, line:1, text:1, tspan:1, defs:1, linearGradient:1, radialGradient:1, stop:1, clipPath:1, use:1 };
  var UNITLESS = { opacity:1, lineHeight:1, fontWeight:1, flex:1, flexGrow:1, flexShrink:1, order:1, zIndex:1, fillOpacity:1, strokeOpacity:1, aspectRatio:1, gridRow:1, gridColumn:1 };
  var ATTR_MAP = { strokeWidth:'stroke-width', strokeOpacity:'stroke-opacity', strokeLinecap:'stroke-linecap', strokeLinejoin:'stroke-linejoin', strokeDasharray:'stroke-dasharray', strokeDashoffset:'stroke-dashoffset', fillOpacity:'fill-opacity', clipPath:'clip-path' };

  function kebab(s) { return s.replace(/[A-Z]/g, function (m) { return '-' + m.toLowerCase(); }); }
  function styleStr(o) {
    var s = '';
    for (var k in o) {
      var v = o[k];
      if (typeof v === 'number' && !UNITLESS[k]) v = v + 'px';
      s += kebab(k) + ':' + v + ';';
    }
    return s;
  }
  function h(tag, props) {
    var isSvg = !!SVG_TAGS[tag];
    var el = isSvg ? document.createElementNS(SVG_NS, tag) : document.createElement(tag);
    if (props) {
      for (var k in props) {
        if (k === 'key') continue;
        var v = props[k];
        if (v == null || v === false) continue;
        if (k === 'style') el.setAttribute('style', styleStr(v));
        else if (k === 'className') el.setAttribute('class', v);
        else el.setAttribute(ATTR_MAP[k] || k, v);
      }
    }
    function add(c) {
      if (c == null || c === false || c === true) return;
      if (Array.isArray(c)) { c.forEach(add); return; }
      if (c instanceof Node) { el.appendChild(c); return; }
      el.appendChild(document.createTextNode(String(c)));
    }
    for (var i = 2; i < arguments.length; i++) add(arguments[i]);
    return el;
  }

  function buildVisuals() {
    var ink='#323232', sub='#6B6560', tert='#89827A', sand='#E5DDD2', oat='#D4CBC0',
      cashmere='#F0EAE0', linen='#FDFCFA', blue='#4A7A96', blueH='#3D6A84',
      sky='#8AAFC4', dawn='#C8DCE8', wash='#EBF2F6';

    var eyebrow = function (c) { return { fontFamily:"'Inter',sans-serif", fontSize:11, fontWeight:600, letterSpacing:'0.14em', textTransform:'uppercase', color:c||tert }; };

    var fig = function (body, note) {
      return h('div', { style:{ background:linen, border:'1px solid '+sand, padding:'26px 26px 22px', height:372, display:'flex', flexDirection:'column' } },
        h('div', { style:{ flex:1, display:'flex', flexDirection:'column', justifyContent:'center', minHeight:0 } }, body),
        note && h('div', { style:{ fontFamily:"'Inter',sans-serif", fontStyle:'italic', fontSize:12, lineHeight:1.5, color:tert, marginTop:18, borderTop:'1px solid '+sand, paddingTop:14, flex:'none' } }, note)
      );
    };

    var pill = function (t) { return h('span', { key:t, style:{ display:'inline-block', padding:'6px 12px', border:'1px solid '+sand, borderRadius:999, fontFamily:"'Inter',sans-serif", fontSize:11, fontWeight:600, letterSpacing:'0.07em', textTransform:'uppercase', color:sub, background:linen } }, t); };

    var dropCol = function (mat, behav, svg) {
      return h('div', { key:mat, style:{ flex:1, minWidth:0, display:'flex', flexDirection:'column', alignItems:'center', gap:10 } },
        h('div', { style:Object.assign({}, eyebrow(tert), { textAlign:'center' }) }, mat), svg,
        h('div', { style:{ fontFamily:"'Satoshi',sans-serif", fontWeight:700, fontSize:15, color:ink } }, behav));
    };
    var svgWrap = function (kids) { return h('svg', { viewBox:'0 0 100 96', width:'100%', style:{ maxWidth:118, display:'block' } }, kids); };
    var cottonSvg = svgWrap([
      h('rect',{ key:'f', x:8, y:46, width:84, height:42, fill:cashmere, stroke:oat, strokeWidth:1 }),
      h('ellipse',{ key:'p1', className:'soak', style:{ '--sd':'0.2s', '--dd':'0s' }, cx:50, cy:68, rx:30, ry:15, fill:'#CBB99E', opacity:0.7 }),
      h('ellipse',{ key:'p2', className:'soak', style:{ '--sd':'0.35s', '--dd':'0.15s' }, cx:50, cy:63, rx:17, ry:8, fill:'#B19877', opacity:0.6 }),
      h('path',{ key:'d', className:'drp', style:{ '--dd':'0s' }, d:'M50 22 C44 32 40 38 50 41 C60 38 56 32 50 22 Z', fill:blue, opacity:0.4 })
    ]);
    var silkSvg = svgWrap([
      h('rect',{ key:'f', x:8, y:46, width:84, height:42, fill:'#ECEDE8', stroke:oat, strokeWidth:1 }),
      h('rect',{ key:'sheen', x:8, y:46, width:84, height:7, fill:'#ffffff', opacity:0.55 }),
      h('path',{ key:'d', className:'drp', style:{ '--dd':'0.35s' }, d:'M50 8 C45 16 42 21 50 23.5 C58 21 55 16 50 8 Z', fill:blue, opacity:0.4 }),
      h('ellipse',{ key:'b', className:'bead', style:{ '--sd':'0.3s', '--dd':'0.35s' }, cx:50, cy:40, rx:15, ry:11, fill:blue, opacity:0.5 }),
      h('ellipse',{ key:'hi', className:'bead', style:{ '--sd':'0.45s', '--dd':'0.35s' }, cx:45, cy:36, rx:4, ry:2.4, fill:'#ffffff', opacity:0.7 })
    ]);
    var cloudSvg = svgWrap([
      h('rect',{ key:'f', x:8, y:46, width:84, height:42, fill:wash, stroke:blue, strokeWidth:1, strokeOpacity:0.5 }),
      h('path',{ key:'d', className:'drp', style:{ '--dd':'0.7s' }, d:'M50 70 C46.5 75 45 78 50 79 C55 78 53.5 75 50 70 Z', fill:blue, opacity:0.5 })
    ].concat([34,50,66].map(function (x,i) {
      return h('g',{ key:'v'+i, className:'vapor', style:{ '--vd':(0.35+i*0.45)+'s' }, stroke:blue, strokeWidth:2, strokeLinecap:'round', strokeLinejoin:'round', opacity:0.7, fill:'none' },
        h('path',{ d:'M'+x+' 40 L'+x+' 17', strokeDasharray:'2 5' }),
        h('path',{ d:'M'+(x-5)+' 24 L'+x+' 15 L'+(x+5)+' 24' }));
    })));
    var dropletTest = fig(
      h('div', { style:{ display:'flex', gap:14, alignItems:'flex-end' } }, dropCol('Cotton','Sponge',cottonSvg), dropCol('Silk','Raincoat',silkSvg), dropCol('CloudThera','Chimney',cloudSvg)),
      '34% greater moisture vapor transmission than cotton, 570 vs 425 g/m²/h, independent lab.'
    );

    var petri = function (n, color, label, amp) {
      var out = [h('circle',{ key:'b', cx:50, cy:50, r:45, fill:'#FAF7F2', stroke:oat, strokeWidth:1.5 })];
      for (var i=0;i<n;i++) {
        var ang=i*2.399; var rad=7+(i/Math.max(n,1))*33;
        var dx=(Math.sin(i*12.9898)*3.2*amp).toFixed(2), dy=(Math.cos(i*78.233)*3.2*amp).toFixed(2);
        out.push(h('circle',{ key:i, className:'pd', style:{ '--pdel0':(i*28)+'ms', '--dx':dx+'px', '--dy':dy+'px', '--pdur':(2.6+((i*7)%5)*0.55)+'s' }, cx:50+rad*Math.cos(ang), cy:50+rad*Math.sin(ang), r:2.6, fill:color }));
      }
      return h('div', { style:{ flex:1, display:'flex', flexDirection:'column', alignItems:'center', gap:12 } },
        h('svg', { viewBox:'0 0 100 100', width:'100%', style:{ maxWidth:172 } }, out),
        h('div', { style:{ fontFamily:"'Inter',sans-serif", fontSize:12, fontWeight:700, letterSpacing:'0.07em', textTransform:'uppercase', color:sub } }, label));
    };
    var petriCompare = fig(
      h('div', { style:{ display:'flex', gap:12, alignItems:'center', justifyContent:'center' } },
        petri(40, '#B5896B', 'Cotton', 1),
        petri(13, blue, 'CloudThera', 0.4)),
      '3× less bacteria vs cotton, cultured surface, Hohenstein Institute.'
    );

    var vcols = function (items) {
      return h('div', { style:{ display:'flex', alignItems:'flex-end', justifyContent:'center', gap:34, height:212 } },
        items.map(function (it,i) {
          return h('div', { key:it.label, style:{ display:'flex', flexDirection:'column', alignItems:'center', height:'100%', justifyContent:'flex-end', flex:'0 0 76px' } },
            h('div', { 'data-count':parseFloat(it.value), 'data-dec':'0', style:{ fontFamily:"'Satoshi',sans-serif", fontWeight:700, fontSize:16, color: it.strong?ink:sub, marginBottom:8 } }, it.value),
            h('div', { className:'bar', style:{ width:'100%', height:it.pct+'%', background:it.color, minHeight:4, animationDelay:(i*0.15)+'s' } }),
            h('div', { style:{ fontFamily:"'Inter',sans-serif", fontSize:12, fontWeight:600, color: it.strong?ink:sub, marginTop:10, textAlign:'center' } }, it.label));
        }));
    };
    var mvtrColumns = fig(
      vcols([{ label:'Cotton', value:'425', pct:53.34, color:oat, strong:false }, { label:'CloudThera', value:'570', pct:80, color:blue, strong:true }]),
      'Moisture vapor transmission, g/m²/h, higher moves more water away from skin. +34% vs cotton.'
    );

    var profile = function (label, value, amp, color, strong, dur, rough) {
      var pts=[];
      for (var x=0;x<=180;x+=2) {
        var y = rough
          ? 20 + amp*(Math.sin(x*Math.PI/15) + 0.45*Math.sin(x*Math.PI/6 + 0.6) + 0.22*Math.sin(x*Math.PI/10 + 1.9))
          : 20 + amp*Math.sin(x*Math.PI/30) + amp*0.5*Math.sin(x*Math.PI/15);
        pts.push(x+','+y.toFixed(2));
      }
      return h('div', { key:label, style:{ marginBottom:18 } },
        h('div', { style:{ display:'flex', justifyContent:'space-between', alignItems:'baseline', marginBottom:6 } },
          h('span', { style:{ fontFamily:"'Inter',sans-serif", fontSize:12, fontWeight:600, color: strong?ink:sub } }, label),
          h('span', { style:{ fontFamily:"'Satoshi',sans-serif", fontWeight:700, fontSize:14, color: strong?ink:sub } }, value)),
        h('svg', { viewBox:'0 0 120 40', width:'100%', preserveAspectRatio:'none', style:{ height:34, display:'block', overflow:'hidden' } },
          h('g', { className:'flowline', style:{ '--fdur':dur+'s' } },
            h('polyline', { points:pts.join(' '), fill:'none', stroke:color, strokeWidth: strong?2.4:1.8, strokeLinecap:'round', strokeLinejoin:'round' }))));
    };
    var surfaceProfile = fig(
      h('div', {}, profile('Cotton','0.25 µm',8,oat,false,4.5,true), profile('Silk','0.15 µm',5,sky,false,6,true), profile('CloudThera','0.11 µm',2.2,blue,true,7.5,true)),
      'Surface roughness profile, flatter is smoother. 56% less friction than cotton, smoother than silk.'
    );

    var person = function (filled, i) {
      return h('svg', { viewBox:'0 0 24 30', width:21, className:'ppl', style:{ display:'block', animationDelay:(i*0.07)+'s' }, key:'p'+i },
        h('circle', { cx:12, cy:7, r:5, fill: filled?blue:'none', stroke: filled?'none':oat, strokeWidth:1.6 }),
        h('path', { d:'M2 30 C2 20 6 16 12 16 C18 16 22 20 22 30 Z', fill: filled?blue:'none', stroke: filled?'none':oat, strokeWidth:1.6 }));
    };
    var pictograph = fig(
      h('div', {},
        h('div', { style:{ display:'grid', gridTemplateColumns:'repeat(5,1fr)', gap:'16px 14px', justifyItems:'center', maxWidth:250, margin:'0 auto' } },
          [0,1,2,3,4,5,6,7,8,9].map(function (i) { return person(i<9,i); })),
        h('div', { style:{ display:'flex', alignItems:'center', gap:10, marginTop:24 } },
          h('span',{ style:{ fontFamily:"'Inter',sans-serif", fontSize:11, fontWeight:600, color:tert } }, 'Day 0'),
          h('div',{ className:'gline', style:{ flex:1, height:6, background:'linear-gradient(90deg,'+sand+','+blue+')' } }),
          h('span',{ style:{ fontFamily:"'Satoshi',sans-serif", fontWeight:700, fontSize:13, color:blueH } }, 'Day 30')),
        h('div', { style:{ fontFamily:"'Inter',sans-serif", fontSize:14, lineHeight:1.5, color:sub, textAlign:'center', marginTop:22, maxWidth:'32ch', marginLeft:'auto', marginRight:'auto' } }, '9 of 10 report noticeably better results')),
      '9 out of 10 report better skin & sleep, survey of over 1,000 sleepers.'
    );

    var washCurve = (function () {
      var pts=[[0,72],[30,52],[58,36],[84,22],[108,12],[120,8]];
      var poly=pts.map(function (p) { return p[0]+','+p[1]; }).join(' ');
      var area=poly+' 120,84 0,84';
      return fig(
        h('div', {},
          h('svg', { viewBox:'0 0 120 84', width:'100%', preserveAspectRatio:'none', style:{ display:'block', height:230 } },
            h('polygon',{ className:'ppl', style:{ animationDelay:'0.6s' }, points:area, fill:wash }),
            h('polyline',{ className:'tr', points:poly, fill:'none', stroke:blue, strokeWidth:2.4, strokeLinecap:'round', strokeLinejoin:'round' })),
          h('div', { style:{ display:'flex', justifyContent:'space-between', marginTop:8, fontFamily:"'Inter',sans-serif", fontSize:11, fontWeight:600, color:sub } },
            h('span',{}, 'Wash 1'), h('span',{}, 'Wash 10'), h('span',{}, 'Wash 20'))),
        'Softens with every wash, where bamboo & cotton degrade. 38 cN/tex, ~50% stronger than cotton.'
      );
    })();

    var hoursVisual = fig(
      h('div', {},
        h('div', {},
          h('div', { style:{ display:'flex', alignItems:'baseline', gap:6 } },
            h('span', { 'data-count':'2920', 'data-dec':'0', style:{ fontFamily:"'Satoshi',sans-serif", fontWeight:700, fontSize:'clamp(40px,5vw,58px)', lineHeight:1, letterSpacing:'-0.02em', color:ink } }, '2,920'),
            h('span', { style:{ fontFamily:"'Satoshi',sans-serif", fontWeight:700, fontSize:26, letterSpacing:'-0.02em', color:blue } }, 'hrs')),
          h('div', { style:{ fontFamily:"'Inter',sans-serif", fontSize:15, color:sub, marginTop:10, lineHeight:1.45, maxWidth:'28ch' } }, 'of skin-on-fabric contact a year, longer than any treatment, mask, or active touches your skin.')),
        h('div', { style:{ display:'flex', flexWrap:'wrap', gap:8, marginTop:22 } }, ['OEKO-TEX certified','Certified hypoallergenic','PETA-vegan'].map(pill))
      )
    );

    return {
      reason1visual: petriCompare,
      reason2visual: hoursVisual,
      reason3visual: dropletTest,
      reason4visual: mvtrColumns,
      reason5visual: surfaceProfile,
      reason6visual: pictograph,
      reason7visual: washCurve
    };
  }

  function init(root) {
    var visuals = buildVisuals();
    Object.keys(visuals).forEach(function (id) {
      var el = root.querySelector('#' + id);
      if (el && visuals[id]) el.appendChild(visuals[id]);
    });
    setupMotion(root);
    setupMarquee(root);
    setupProductScroll(root);
  }

  function setupProductScroll(root) {
    var el = root.querySelector('.dreamey-product-showcase__scroll');
    if (!el) return;
    var TH = 6, down = false, dragging = false, startX = 0, startLeft = 0;
    el.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      down = true; dragging = false; startX = e.pageX; startLeft = el.scrollLeft;
    });
    window.addEventListener('mousemove', function (e) {
      if (!down) return;
      var dx = e.pageX - startX;
      if (!dragging && Math.abs(dx) > TH) { dragging = true; el.classList.add('is-dragging'); }
      if (dragging) { el.scrollLeft = startLeft - dx; e.preventDefault(); }
    });
    window.addEventListener('mouseup', function () {
      if (!down) return;
      down = false;
      if (!dragging) return;
      var suppress = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
      el.addEventListener('click', suppress, { capture: true, once: true });
      setTimeout(function () { el.removeEventListener('click', suppress, { capture: true }); el.classList.remove('is-dragging'); dragging = false; }, 0);
    });
  }

  function setupMarquee(root) {
    var wrap = root.querySelector('.marquee-wrap');
    if (!wrap) return;
    var track = wrap.querySelector('.marquee-track');
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var half = 0;
    function measure() { half = track ? track.scrollWidth / 2 : 0; }
    measure();
    var dragging = false, hover = false, startX = 0, startScroll = 0, pos = 0;
    var auto = !reduced, speed = 0.35;
    function step() {
      if (!half) measure();
      if (auto && !dragging && !hover && half) {
        // Accumulate a float position: mobile browsers round scrollLeft to integers,
        // so `+= 0.35` alone never advances. Tracking pos and assigning it works everywhere.
        pos += speed;
        if (pos >= half) pos -= half;
        wrap.scrollLeft = pos;
      } else {
        pos = wrap.scrollLeft;
      }
      requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
    window.addEventListener('load', measure);
    wrap.addEventListener('mouseenter', function () { hover = true; });
    wrap.addEventListener('mouseleave', function () { hover = false; });
    wrap.addEventListener('dragstart', function (e) { e.preventDefault(); });
    wrap.addEventListener('pointerdown', function (e) {
      dragging = true; wrap.classList.add('dragging');
      startX = e.clientX; startScroll = wrap.scrollLeft;
      try { wrap.setPointerCapture(e.pointerId); } catch (_) {}
    });
    wrap.addEventListener('pointermove', function (e) {
      if (!dragging || !half) return;
      wrap.scrollLeft = startScroll - (e.clientX - startX);
      if (wrap.scrollLeft <= 0) { wrap.scrollLeft += half; startScroll += half; }
      else if (wrap.scrollLeft >= half) { wrap.scrollLeft -= half; startScroll -= half; }
    });
    function endDrag() { dragging = false; wrap.classList.remove('dragging'); }
    wrap.addEventListener('pointerup', endDrag);
    wrap.addEventListener('pointercancel', endDrag);
    window.addEventListener('resize', measure);
  }

  function setupMotion(root) {
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var fmt = function (v, dec) { return dec > 0 ? v.toFixed(dec) : Math.round(v).toLocaleString('en-US'); };
    var runCount = function (el) {
      if (el.getAttribute('data-cnt-done')) return;
      el.setAttribute('data-cnt-done', '1');
      var target = parseFloat(el.getAttribute('data-count'));
      if (isNaN(target)) return;
      var dec = parseInt(el.getAttribute('data-dec') || '0', 10);
      if (reduced) { el.textContent = fmt(target, dec); return; }
      var t0 = performance.now(), dur = 1500;
      var step = target >= 1000 ? 10 : 1;
      var tick = function (now) {
        var t = Math.min(1, (now - t0) / dur);
        var eased = 1 - Math.pow(1 - t, 3);
        var v = target * eased;
        if (t < 1 && step > 1 && dec === 0) v = Math.round(v / step) * step;
        el.textContent = fmt(t < 1 ? v : target, dec);
        if (t < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };

    var toArr = function (nl) { return Array.prototype.slice.call(nl); };
    var addReveal = function (el, i) { if (!el) return; el.classList.add('reveal'); if (i != null) el.style.setProperty('--i', Math.min(i, 12)); };
    var stagger = function (list) { toArr(list).forEach(function (el, i) { addReveal(el, i); }); };

    var statCells = root.querySelectorAll('.stat-grid > div');
    stagger(statCells);
    toArr(statCells).forEach(function (cell) {
      toArr(cell.querySelectorAll('span, div')).forEach(function (c) {
        var txt = (c.textContent || '').trim();
        if (!c.children.length && /^[0-9]+(\.[0-9]+)?$/.test(txt) && !c.hasAttribute('data-count')) {
          c.setAttribute('data-count', txt);
          c.setAttribute('data-dec', txt.indexOf('.') >= 0 ? String(txt.split('.')[1].length) : '0');
        }
      });
    });

    toArr(root.querySelectorAll('[data-rv]')).forEach(function (v) {
      var copy = v.previousElementSibling;
      if (copy) stagger(copy.children);
    });

    toArr(root.querySelectorAll('[data-stagger]')).forEach(function (grp) { stagger(grp.children); });

    var dg = root.querySelector('.doctor-grid'); if (dg) stagger(dg.children);

    stagger(root.querySelectorAll('details.faq-item'));

    // Comparison table: reveal one row at a time (staggered), like the home page
    stagger(root.querySelectorAll('.dsl-trow'));

    toArr(root.querySelectorAll('h2')).forEach(function (hEl) {
      if (hEl.closest('.reveal')) return;
      var prev = hEl.previousElementSibling;
      if (prev && !prev.classList.contains('reveal')) addReveal(prev, 0);
      addReveal(hEl, prev ? 1 : 0);
    });

    toArr(root.querySelectorAll('.pad')).forEach(function (sec) {
      var i = 0;
      toArr(sec.children).forEach(function (child) {
        if (child.classList.contains('reveal') || child.hasAttribute('data-rv') ||
            child.hasAttribute('data-stagger') || child.querySelector('.reveal, [data-rv]')) { i++; return; }
        addReveal(child, i++);
      });
    });

    addReveal(root.querySelector('.mq-body'));

    var revealEls = root.querySelectorAll('.reveal, [data-rv]');

    if (reduced || !('IntersectionObserver' in window)) {
      toArr(revealEls).forEach(function (el) {
        el.classList.add('is-in');
        if (el.hasAttribute('data-rv')) el.classList.add('rv-in');
      });
      toArr(root.querySelectorAll('[data-count]')).forEach(runCount);
      return;
    }

    root.classList.add('anim-ready');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        el.classList.add('is-in');
        if (el.hasAttribute('data-rv')) el.classList.add('rv-in');
        toArr(el.querySelectorAll('[data-count]:not([data-cnt-done])')).forEach(runCount);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    toArr(revealEls).forEach(function (el) { io.observe(el); });
  }

  function boot() {
    var roots = document.querySelectorAll('.dreamey-skin-listicle');
    Array.prototype.slice.call(roots).forEach(function (root) {
      if (root.getAttribute('data-dsl-init')) return;
      root.setAttribute('data-dsl-init', '1');
      init(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
